<div class="container-xxl">
  <router-outlet></router-outlet>
</div>